import { useEffect, useState } from "react";
import { iAuth, iTenant, iTenants, iTenantsResponse } from "../../interfaces/auth";
import {
    getRecentTenants,
    getTenantAccess,
    getTenants,
    logout,
    refreshIDPToken,
    saveRecentTenant,
    setTenantContext,
} from "../../Logic/Auth/TokenManager";
import { useNavigate } from "react-router-dom";
import "../template/styles/generic-components.scss";
import {
    getElevateValue,
    getLocalValue,
    removeLocalValue,
    removeSessionValue,
    saveLocalValue,
    saveSessionValue,
} from "../../utilities/localStore/calls";
import ToggleSwitch from "../Generic/ToggleSwitch";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { logErrorToService } from "../../error-boundary/logerror";

function Auth() {
    const navigate = useNavigate();
    const [tenants, setTenants] = useState<iTenantsResponse | undefined>(undefined);
    const [showSystemAccess, setShowSystemAccess] = useState<boolean | undefined>(undefined);
    const [hasTenantError, SetHasTenantError] = useState<boolean | undefined>(undefined);
    const [logoutMessage, setLogoutMessage] = useState("");

    useEffect(() => {
        (async () => {
            var urlParts = window.location.href.substring(window.location.href.indexOf("://") + 3).split("/");
            let redirectURL = "";
            if (urlParts.length > 1 && urlParts[1] != "") {
                redirectURL = "?_referer=" + urlParts[1].replace("?_referer=", "");
            }
            const crypto = getLocalValue<iAuth>("auth");
            if (crypto === null) {
                navigate("/auth/callback/" + redirectURL);
            } else if (crypto != null) {
                if (crypto.code == "") {
                    navigate("/auth/callback/" + redirectURL);
                } else {
                    await getTentantsAccess();
                }
            }

            switch (crypto?.theme) {
                case 1:
                    import("../template/styles/themes/om.scss");
                    break;
                default:
                    import("../template/styles/themes/default.scss");
                    break;
            }
        })();
    }, []);

    const getTentantsAccess = async () => {
        try {
            const tenantsResponse = await getTenants();
            saveSessionValue("tenant", {
                name: "",
                key: "",
                token: "",
                accessToMultipleTenants: tenantsResponse.tenants.length > 1 ? true : false,
                expiresIn: 0,
            });
            if (window.location.href.indexOf("?_referer=") > 0 && tenantsResponse.tenants.length > 0) {
                const tenant = tenantsResponse.tenants.filter(
                    x =>
                        x.key.toLowerCase() ==
                        window.location.href.substring(window.location.href.indexOf("?_referer=") + 10).toLowerCase(),
                );
                if (tenant.length > 0) {
                    getTenantA(tenantsResponse);
                }
            } else {
                getTenantA(tenantsResponse);
            }
        } catch (err: any) {
            if (err.message == "401") {
                await refreshIDPToken();
                getTentantsAccess();
            }
        }
    };

    async function getTenantA(tData: iTenantsResponse) {
        let elevateVal = getElevateValue();

        if (tData.isAdmin) {
            if (!elevateVal) {
                saveLocalValue("elevate", false);
                setShowSystemAccess(false);
            } else {
                setShowSystemAccess(elevateVal);
            }
        } else {
            removeLocalValue("elevate");
        }

        if (tData.tenants.length == 1 && localStorage.getItem("logoutMessage") == null) {
            try {
                await getTenantAccess(tData.tenants[0]);
                window.location.href = "/" + tData.tenants[0].key;
            } catch (e) {
                SetHasTenantError(true);
                logErrorToService(new Error("Error Logging Into Site:ErrorCode:#T001# "));
            }
        } else if (tData.tenants.length == 0) {
            logErrorToService(new Error("Error Logging Into Site:ErrorCode:#UG001#"));
        } else {
            setTenants(tData);
        }
    }

    let lastRecentTenants: iTenant[] = getRecentTenants();
    const handleTenantSelection = async (tenant: iTenant) => {
        saveRecentTenant(tenant);
        try {
            await getTenantAccess(tenant);
            localStorage.removeItem("logoutMessage");
            window.location.href = "/" + tenant.key;
        } catch (e) {
            SetHasTenantError(true);
            logErrorToService(new Error("Error Logging Into Site:ErrorCode:#T001# "));
        }
    };

    function Retry() {
        logout();
        navigate("/auth/callback/");
    }
    useEffect(() => {
        const message = localStorage.getItem("logoutMessage");
        if (message) {
            setLogoutMessage(message);
        }
        window.setTimeout(() => {
            localStorage.removeItem("logoutMessage");
        }, 2000);
    }, [localStorage.getItem("logoutMessage")]);

    return (
        <>
            {hasTenantError && (
                <div className="centered-error">
                    <div>
                        You do not have access to the system. Please contact Support or click the retry button.
                        <br />
                        Error Code:#T001#
                    </div>
                    <br />
                    <button
                        className="error-button"
                        onClick={() => Retry()}
                    >
                        Retry Login
                    </button>
                </div>
            )}
            {getLocalValue<iAuth>("auth") != null && tenants && tenants.tenants.length == 0 && (
                <div className="centered-error">
                    <div>
                        You do not have access to the system. Please contact Support or click the retry button.
                        <br />
                        Error Code:#UG001#
                    </div>
                    <br />
                    <button
                        className="error-button"
                        onClick={() => Retry()}
                    >
                        Retry Login
                    </button>
                </div>
            )}
            {!hasTenantError && getLocalValue<iAuth>("auth") != null && tenants && tenants.tenants.length > 0 && (
                <>
                    <div className="multi-tenant-wrap">
                        <div className="multi-tenant-login">
                            <div className="multi-tenant-login--head">
                                <div className="multi-tenant-login--head--logo"></div>
                                <div
                                    className="multi-tenant-login--head--ems-header"
                                    id="tenantNameText"
                                ></div>
                            </div>
                            {showSystemAccess != undefined && (
                                <div className="systemAccess">
                                    <div className="header">Elevated System Access</div>
                                    <div style={{ width: "40px" }}>
                                        <ToggleSwitch
                                            name="systemAccess"
                                            label=""
                                            value="true"
                                            checked={showSystemAccess}
                                            returnFunc={() => {
                                                saveLocalValue("elevate", !showSystemAccess);
                                                setShowSystemAccess(!showSystemAccess);
                                            }}
                                        ></ToggleSwitch>
                                    </div>
                                </div>
                            )}
                            {logoutMessage && <div className="LogoutMessage">{logoutMessage}</div>}
                            <div className="multi-tenant-login--tenants">
                                <div className="multi-tenant-login--tenants--header">Available tenants</div>
                                <div className="multi-tenant-login--tenants--lists">
                                    {lastRecentTenants.length > 0 && (
                                        <div className="tenant-select-recent">
                                            <p className="multi-tenant-login--tenants--lists--list-header">Recent</p>
                                            <div className="recent-tenants scroll-small">
                                                {lastRecentTenants.map(tenant => (
                                                    <div
                                                        className="tenant-select--option"
                                                        key={tenant.key}
                                                        onClick={() => handleTenantSelection(tenant)}
                                                    >
                                                        <div className="tenant-select--option--label">
                                                            {tenant.name}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    <div className="all-list">
                                        <br></br>
                                        <p className="multi-tenant-login--tenants--lists--list-header">All</p>
                                        <div className="allScroll">
                                            <div className="tenant-select scroll-small">
                                                {tenants.tenants
                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                    .map(tenant => (
                                                        <div
                                                            className="tenant-select--option"
                                                            key={tenant.key}
                                                            onClick={() => handleTenantSelection(tenant)}
                                                        >
                                                            <div className="tenant-select--option--label">
                                                                {tenant.name}
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {!hasTenantError && (
                <div
                    style={{
                        height: "100%",
                        width: "100%",
                        zIndex: 2147483647,
                        position: "absolute",
                        top: "0px",
                        left: "0px",
                        display: "none",
                        cursor: "wait",
                        justifyContent: "center",
                    }}
                    id="loader"
                >
                    <div className="notice loading">Still busy. Please wait...</div>
                </div>
            )}
        </>
    );
}
export default Auth;
